import React from 'react'

import { GenericOfficialPage } from 'ui/pages/GenericOfficialPage'
import { Typo } from 'ui/theme'

export const CheatcodesScreenGenericOfficialPage = () => {
  return (
    <GenericOfficialPage title="Title">
      <Typo.Body>Children...</Typo.Body>
    </GenericOfficialPage>
  )
}
